import classNames from 'classnames';
import React from 'react';

interface Props {
    onChange: (value: string) => void;
    value?: string;
    onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
    id?: string;
    placeholder?: string;
    type?: string;
    fill?: boolean;
    onKeyPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;

    // FIXME: Use React.forwardRef once fixed in enzyme
    // @see https://github.com/airbnb/enzyme/issues/1604
    forwardedRef?: React.RefObject<HTMLInputElement>;

    autoFocus?: boolean;
    disabled?: boolean;

    maxLength?: number;
}

const Text: React.SFC<Props> = ({ onChange, fill, forwardedRef, disabled, ...props }) => {
    const classes = classNames('input-text', {
        'input-width--max': fill,
    });

    return (
        <input
            ref={forwardedRef}
            {...props}
            className={classes}
            onChange={({ target: { value } }) => onChange(value)}
            disabled={disabled}
            maxLength={props.maxLength}
        />
    );
};

Text.defaultProps = {
    type: 'text',
    fill: false,
    disabled: false,
};

export default Text;
